import { AssetDTO, speakersDto, typeDetails } from "src/app/shared/models/models";
import { contactsDTO } from "../../../exhibitions/services/models/exhibitionpage.model";

export class flatData{
  speakername:string = '';
  speakerphoto:AssetDTO = new AssetDTO();
  positiontitle:string = '';
}
export class speakers{
  flatData:flatData = new flatData()
}
export class SeminarpageContentDetails {
  seminarTitle:string = '';
  aboutSeminar:string = '';
  startDate:string = '';
  endDate:string = '';
  locationName:string = '';
  locationGeo:string = '';
  coverImage: AssetDTO= new AssetDTO();
  speakers:speakers= new speakers();
  contacts:contactsDTO = new contactsDTO();

  
}

export class items {
  id:string = '';
  flatData: SeminarpageContentDetails = new SeminarpageContentDetails();
} 

export class SeminarpageContentModel {
  total:number = 0;
  items:items = new items();
  
}